export const educationData = [
    {
        id: 1,
        institution: 'University of Pennsylvania',
        link: 'https://www.upenn.edu',
        logo: '/img/education/UPenn.png',
        course: 'Master\'s Degree',
        startYear: '2021',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Lehigh University',
        link: 'https://www2.lehigh.edu',
        logo: '/img/education/Lehigh.svg',
        course: 'Bachelor\'s Degree',
        startYear: '2017',
        endYear: '2021'
    },
    {
        id: 3,
        institution: 'Khartoum American School (Sudan)',
        link: 'https://www.krtams.org',
        logo: '',
        course: 'High School Diploma',
        startYear: '2012',
        endYear: '2017'
    },
]